module.exports = __webpack_public_path__ + "static/media/0021_IMG_BVP.c9b8c473.webp";